import React, { Component, PropTypes } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import IdUploaded from 'registration/creative/containers/id_uploaded';
import { isMobile } from 'common/utils';
import moment from 'moment';

/**
 * Screen shown while waiting for ID and selfie pictures upload
 * to be completed on the user's mobile device. If already on mobile,
 * there's nothing else to be done since the process will continue
 * on another tab.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class WaitIdCapture extends Component {
  constructor(props) {
    super(props);

    this.state = { timer: null, startedWaitingAt: moment(), linkResent: false };

    this.resendLink = this.resendLink.bind(this);
  }

  resendLink() {
    this.props.resendPhoneVerification(true);
    this.setState({ linkResent: true });
  }

  componentDidMount() {
    /* check if upload is complete every 5 seconds */
    if (!isMobile()) {
      this.setState({timer: setInterval(() => this.props.fetchIdPhotoIfNeeded(true), 5000)})
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.timer)
  }

  render() {
    const {
      idPhoto, selfie, onComplete, submittedAt, cancelPhoneVerification, resendPhoneVerification
    } = this.props;
    const { linkResent } = this.state;
    const mobile = isMobile();

    /* ID photo and selfie uploaded AFTER we started to wait */
    if (idPhoto && moment(submittedAt).isAfter(this.state.startedWaitingAt)) {
      return <IdUploaded idPhoto={idPhoto} selfie={selfie} onNext={onComplete}/>
    }

    return (
      <div className="wait-id-capture done">
        <h3 className="text-success">
          <i className="fa fa-check-circle" /> Verification Sent!
        </h3>
        { mobile?
        <p>
          Open the link we sent you and follow the instructions.<br/>
          You can close this window now.
        </p>:
        <div>
          <p>
            Open the link on your smartphone and follow the instructions.<br/>
            Please be patient - it could take up to 1 minute for you to receive the
            SMS link on your smartphone.
          </p>
          <p>
            Please don't close this window until you submit the photos on your smartphone.
          </p>
          <p>
            This window will automatically refresh when you've completed
            verification on your smartphone.
          </p>
        </div> }

        { !mobile && <LoadingIndicator fullScreen={false} /> }

        <div className="alternatives">
          <div className="alternative">
            <label>Haven't received your link yet?</label>
            { linkResent?
            <strong> Done.</strong> :
            <button className="btn btn-text btn-md" onClick={this.resendLink}>
              Resend SMS
            </button> }
          </div>
          <div className="alternative">
            <label>Still having problems?</label>
            <button className="btn btn-text btn-md" onClick={cancelPhoneVerification}>
              Use another verification method
            </button>
          </div>
        </div>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./registration/creative/components/wait_id_capture.jsx